// @ts-nocheck
/* eslint-disable */
export const niDropdownDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 4"><path d="M312 689L316 693 320 689" transform="translate(-311 -2605) translate(0 1916)" stroke="#054123" class="svg-desktop-stroke-tag" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'dropdown-down' as const
};